import { Box, Container, Typography } from "@mui/material";

import RenderAnimation from "../../util/ui/renderAnimation";
import { useUsuario } from "../../../providers/usuarioProvider";
import { Perfil } from "../../../models/enum";
import { radius } from "../../../theme";

export default function AssinaturaConfirmada() {
  const { usuario, claims } = useUsuario();
  return (
    <Container
      maxWidth="md"
      sx={(theme) => ({
        textAlign: "center",
        padding: {
          md: theme.spacing(4, 8),
          xs: theme.spacing(2, 2),
        },
      })}
    >
      <Box py={2}>
        <RenderAnimation
          delay={0 * 300}
          render={() => (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={1}
            >
              <Typography variant="eyebrow" color="text.secondary">
                Assinatura confirmada
              </Typography>
              <Typography variant="h1" color="text.primary">
                {!!usuario?.nome
                  ? `🏆 Boas-vindas, ${usuario.nome}!`
                  : "🏆 Boas-vindas!"}
              </Typography>
            </Box>
          )}
        />
      </Box>
      <Box
        py={2}
        sx={{
          "& iframe": {
            display: "block",
            border: 1,
            borderColor: "divider",
            borderRadius: `${radius.xl}px`,
            backgroundColor: "background.paper",
          },
        }}
      >
        <iframe
          width="100%"
          height="512"
          src={
            claims && claims.perfil === Perfil.CONTADOR
              ? "https://www.youtube.com/embed/s_zfxpyKTCo"
              : "https://www.youtube.com/embed/gAGUaZi3Awc"
          }
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Rawww | Felix na Bolsa"
        ></iframe>
      </Box>
    </Container>
  );
}
